import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';
import { AiAutoReplyConfigModel, LocationModel, UpgradePlanRequest } from '@models/index';


@Injectable({
    providedIn: 'root',
})
export class LocationsService {
    constructor(
        private http: HttpClient
    ) { }

    searchLocations(payload: { page: number; size: number; id: string }): Observable<{ data: LocationModel[], total: number }> {
        return this.http
            .get<{ data: LocationModel[], total: number }>(`${environment.apiPath}/locations/business?page=${payload.page}&size=${payload.size}&id=${payload.id}`)
            .pipe(
                map((items: { data: LocationModel[], total: number }) => ({
                    data: items.data,
                    total: items.total
                }))
            );
    }

    searchArchivedLocations({ businessId }): Observable<string[]> {
        return this.http
            .get<string[]>(`${environment.apiPath}/locations/archived?id=${businessId}`)
            .pipe(
                map(data => data)
            );
    }

    findLocationById(locationId: string): Observable<LocationModel> {
        return this.http
            .get<LocationModel>(`${environment.apiPath}/locations/${locationId}`)
            .pipe(
                map(data => data)
            );
    }

    searchLocationsByQuery(payload: { page: number, size: number, query: string, businessId: string }): Observable<{ data: LocationModel[], total: number }> {
        return this.http
            .get(`${environment.apiPath}/locations/autocomplete?page=${payload.page}&size=${payload.size}&query=${payload.query}&businessId=${payload.businessId}`)
            .pipe(
                map((items: { data: LocationModel[], total: number }) => ({
                    data: items.data,
                    total: items.total
                })),
            );
    }

    editLocation(location: LocationModel): Observable<LocationModel> {
        return this.http
            .post<LocationModel>(`${environment.apiPath}/locations/edit`, location)
    }

    addLocation(location: LocationModel): Observable<LocationModel> {
        return this.http
            .post<LocationModel>(`${environment.apiPath}/locations`, location)
    }

    deleteLocation(locationId: string): Observable<string> {
        return this.http
            .post<string>(`${environment.apiPath}/locations/${locationId}`, {})
            .pipe(
                map((item) => item["data"])
            )
    }

    archiveLocation(locationId: string): Observable<string> {
        return of(locationId)
    }

    getUrls(locationId: string): Observable<Object[]> {
        return this.http
            .get<Object[]>(`${environment.apiPath}/locations/url/${locationId}`)

    }

    searchLocationsByQueryAndLandingUrls(payload: { page: number, size: number, query: string, businessId: string }): Observable<{ data: LocationModel[], total: number }> {
        return this.http
            .get(`${environment.apiPath}/locations/landings?page=${payload.page}&size=${payload.size}&query=${payload.query}&businessId=${payload.businessId}`)
            .pipe(
                map((items: { data: LocationModel[], total: number }) => ({
                    data: items.data,
                    total: items.total
                })),
            );
    }
    upgradePlan(upgradePlan: UpgradePlanRequest): Observable<LocationModel> {
        return this.http
            .post<LocationModel>(`${environment.apiPath}/locations/upgrade-plan`, upgradePlan)
    }
    enableOrDisableAutoReplyAi(payload: { locationId: string, data: AiAutoReplyConfigModel }): Observable<LocationModel> {
        return this.http
            .post<LocationModel>(`${environment.apiPath}/locations/enable-or-disable-auto-reply-ai`, payload)
            .pipe(
                map(data => data)
            );
    }
    
}